import { useState } from "react";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <p className="text-xs font-medium tracking-widest text-secondary-700">FAQ · 常见问题</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            关于蝌蚪爆料，你可能想问
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            还有别的问题，可以在联系与投稿页面留言，编辑会逐条查看并回复。
          </p>
        </div>

        <div className="lg:col-span-8">
          <dl className="divide-y divide-background-200 border-y border-background-200">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div key={item.q}>
                  <dt>
                    <button
                      type="button"
                      aria-expanded={open}
                      onClick={() => setOpenIndex(open ? null : index)}
                      className="flex w-full items-center justify-between gap-4 py-5 text-left"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {item.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors ${
                          open
                            ? "border-primary-500 bg-primary-500 text-background-50"
                            : "border-background-300 text-foreground-600"
                        }`}
                      >
                        <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} />
                      </span>
                    </button>
                  </dt>
                  {open ? (
                    <dd className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </dd>
                  ) : null}
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
}